module.exports = __webpack_public_path__ + "static/media/airpods_pro_dark.6de49eb3.svg";